import { render, staticRenderFns } from "./Totals.vue?vue&type=template&id=88c23886&"
import script from "./Totals.vue?vue&type=script&lang=js&"
export * from "./Totals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports